
import { useState, useEffect } from 'react';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useAdmin } from '@/hooks/useAdmin';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CountdownTimer } from './CountdownTimer';

export const PromotionalPopup = () => {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useLocalStorage('promotional-popup-dismissed', false);
  const { isAdmin } = useAdmin();
  
  // Immediately mark as dismissed - the launch date has passed
  useEffect(() => {
    // The launch has already happened, so we don't need to show this popup anymore
    setDismissed(true);
  }, [setDismissed]);
  
  // Always return null since the promotion is over
  return null;
};
